import { render, staticRenderFns } from "./CustomerDialog.vue?vue&type=template&id=eb5857c4&scoped=true"
import script from "./CustomerDialog.vue?vue&type=script&lang=js"
export * from "./CustomerDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerDialog.vue?vue&type=style&index=0&id=eb5857c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5857c4",
  null
  
)

export default component.exports